module.exports = __webpack_public_path__ + "img/partners_0.b6b163c5.png";